import React, { useState } from "react";

const plans = [
  {
    id: "starter",
    title: "Starter",
    subtitle: "Perfect for solo entrepreneurs",
    priceMonthly: "$19",
    priceYearly: "$15",
    period: "/mo",
    image: "assets/images/right-5.png",
    features: [
      "1 Store",
      "Up to 2 team members",
      "50,000 API Calls / month",
      "Up to 500 Products",
      "5 Email Campaigns per month",
      "Unlimited Invoices, Sliders, Popups",
      "Shipping Zones Unlimited",
      "Custom Branding, Inventory & Analytics",
      "Email Support",
      "No Transaction Fees",
    ],
    buttonText: "Start 14-Day Free Trial",
    buttonLink: "https://app.fexila.com/register",
    buttonClass: "btn btn-outline-primary mt-3",
    cardClass: "",
    badge: null,
    cardStyle: {},
  },
  {
    id: "professional",
    title: "Professional",
    subtitle: "Best for growing businesses",
    priceMonthly: "$79",
    priceYearly: "$63",
    period: "/mo",
    image: "assets/images/badge.png",
    features: [
      "Manage Up to 5 Stores",
      "Up to 15 team members",
      "500,000 API Calls / month",
      "Up to 10,000 Products",
      "50 Email Campaigns per month",
      "Unlimited Invoices, Sliders, Popups",
      "Shipping Zones Unlimited",
      "Custom Branding, Inventory & Analytics",
      "Email + Chat Support",
      "No Transaction Fees",
    ],
    buttonText: "Start 14-Day Free Trial",
    buttonLink: "https://app.fexila.com/register",
    buttonClass: "btn btn-primary mt-3 btn-lg",
    cardClass: "position-relative border-3 pricing-card featured",
    badge: "Most Popular",
    cardStyle: {
      border: "3px solid #e34848",
      backgroundColor: "#fff8f3",
      borderRadius: "25px",
      boxShadow: "0 8px 30px rgba(227,72,72,0.25)",
    },
  },
  {
    id: "enterprise",
    title: "Enterprise",
    subtitle: "Custom solutions for large-scale needs",
    priceMonthly: "Custom",
    priceYearly: "Custom",
    period: "",
    image: "assets/images/shield.png",
    features: [
      "Unlimited Stores",
      "Unlimited team members",
      "Custom API Call Volume",
      "Unlimited Products",
      "Unlimited Email Campaigns",
      "Unlimited Invoices, Sliders, Popups",
      "Unlimited Shipping Zones",
      "Custom Branding, Inventory & Analytics",
      "Dedicated Account Manager",
      "No Transaction Fees",
    ],
    buttonText: "Contact Sales",
    buttonLink: "https://app.fexila.com/register",
    buttonClass: "btn btn-outline-primary mt-3",
    cardClass: "",
    cardStyle: {},
  },
];

const Pricing = () => {
  const [activeTab, setActiveTab] = useState("monthly");

  return (
    <div className="container">
      <section className="section" id="pricing" aria-label="Pricing Plans">
        {/* Heading */}
        <div className="text-center mb-4">
          <h2 className="fw-bold">Our Pricing Plans</h2>
          <p className="col-lg-6 col-md-8 col-11 mx-auto">
            Choose the perfect plan for your business — start free, scale fast,
            and cancel anytime.
          </p>
        </div>

        {/* Tab Buttons */}
        <div className="appie-pricing-tab-btn mb-5">
          <ul className="nav justify-content-center mt-3">
            <li className="nav-item-tab">
              <a
                href="#"
                className={`nav-link ${
                  activeTab === "monthly" ? "active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("monthly");
                }}
              >
                Monthly
              </a>
            </li>
            <li className="nav-item">
              <a
                href="#"
                className={`nav-link ${activeTab === "yearly" ? "active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("yearly");
                }}
              >
                Yearly
              </a>
            </li>
          </ul>
        </div>

        {/* Pricing Cards */}
        <div className="row g-5 justify-content-center">
          {plans.map((plan) => (
            <div
              className="col-lg-4 col-md-6 col-12 mx-auto"
              key={plan.id}
              role="region"
              aria-labelledby={`${plan.id}-plan`}
            >
              <div
                className={`card h-100 text-center ${plan.cardClass}`}
                style={plan.cardStyle}
              >
                {plan.badge && (
                  <span
                    className="badge bg-danger position-absolute start-50 translate-middle-x rounded-pill"
                    style={{
                      zIndex: 10,
                      marginTop: "-18px",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    {plan.badge}
                  </span>
                )}
                <div className="card-body">
                  <img
                    src={plan.image}
                    alt={plan.title}
                    style={{ display: "inline-block", paddingTop: "24px" }}
                  />
                  <h3
                    id={`${plan.id}-plan`}
                    className={`fw-bold mt-3 ${
                      plan.id === "professional" ? "text-danger" : ""
                    }`}
                  >
                    {plan.title}
                  </h3>
                  <p className="text-muted small">{plan.subtitle}</p>

                  {/* Responsive Price */}
                  <div className="d-flex justify-content-center align-items-baseline flex-wrap mb-3">
                    <span
                      className={`display-5 fw-bold ${
                        plan.id === "professional" ? "text-danger" : "text-dark"
                      } me-2`}
                    >
                      {activeTab === "monthly"
                        ? plan.priceMonthly
                        : plan.priceYearly}
                    </span>
                    {plan.period && (
                      <span className="fs-6 text-muted">{plan.period}</span>
                    )}
                  </div>

                  <hr
                    style={{
                      border: "none",
                      height: "1px",
                      backgroundColor: "#e34848",
                    }}
                  />

                  {/* Features */}
                  <ul className="list-unstyled mb-3">
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>

                  <a
                    href={plan.buttonLink}
                    className={plan.buttonClass}
                    style={{
                      width: "180px",
                      ...(plan.id === "professional"
                        ? { boxShadow: "0 4px 15px rgba(227,72,72,0.4)" }
                        : {}),
                    }}
                  >
                    {plan.buttonText}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Text */}
        <p className="mx-auto text-center mt-5 text-danger fs-5 col-11 col-md-8">
          Trusted by <strong>1200+</strong> store owners worldwide. No hidden
          fees. Secure payments.
        </p>
      </section>
    </div>
  );
};

export default Pricing;
